import { Radio } from '@frontend/legacy-components';

import HeaderCellContent from '../subcomponents/HeaderCellContent';
import SelectionCheckbox from '../subcomponents/SelectionCheckbox';
import { useTableContext } from './TableContext';
import constants from './constants';

/* Column translation -->
 * extract certain props and transform each column's object into the appropriate input to rc-table's columns; i.e.
 * sortOptions becomes a special set of classNames that govern its functionality.
 */
const HeaderCheckbox = () => {
  const { data } = useTableContext();
  return (
    <SelectionCheckbox record={{ key: '_all', children: data }} isMainParent />
  );
};

const translateColumns = (
  columns,
  onSelect,
  selectionSingleSelect,
  selectionHideGlobal,
  tableLayout,
) => {
  const tempTranslatedColumns = [];
  // Create a temp store for our created filterConfigs for each column.
  const tempFilterConfigs = {};

  if (onSelect != null) {
    tempTranslatedColumns.push({
      key: columns[0].key + '_selection', // A unique key based on the 1st column.
      title:
        /* Added true equality check because an object from storybook was being accepted as true*/
        selectionSingleSelect !== true && selectionHideGlobal !== true ? (
          <HeaderCheckbox />
        ) : undefined,
      align: 'center',
      fixed: 'left',
      className: 'selection-cell',
      /* Only apply column widths in fixed table layouts to ensure consistency between safari and chromium*/
      width: tableLayout === 'fixed' ? '2.75rem' : undefined,
      render(record) {
        if (
          record.selection == null ||
          record.selection != constants.selection.hidden
        ) {
          /* Added true equality check because an object from storybook was being accepted as true*/
          if (selectionSingleSelect === true) {
            return (
              <Radio
                value={record.key}
                isDisabled={record.selection === constants.selection.disabled}
              />
            );
          } else {
            return (
              <SelectionCheckbox
                record={record}
                isDisabled={record.selection === constants.selection.disabled}
              />
            );
          }
        }
      },
    });
  }

  // iterate through every column object and push the translated object to our temp store;
  columns.forEach(
    /* deconstruct to extract special extra props we use that aren't a part of rc-table...
          ...as well as keys we need to reference, assigning default values as needed. */
    ({
      filterOptions = {},
      dataIndex,
      title,
      className = '',
      width,
      ...column
    }) => {
      // deconstruct filter options from column prop; default to both sort directions if it exists
      const {
        sortDirections = [],
        filterInputComponent = null,
        formatter,
        empty,
      } = filterOptions;

      // Pair down the input sortDirections to only contain the values in constants.possibleSortDirections...
      // ... Removing the potential for error if incorrect values are passed in by the engineer when using the table.
      const cleanedSortDirections = sortDirections.filter(function (el) {
        return constants.possibleSortDirections.includes(el);
      });

      let finalClassName = className + ' ';
      cleanedSortDirections.forEach((cleanedSortDirection) => {
        finalClassName += 'sortable-' + cleanedSortDirection + ' ';
      });

      // If the column has sorting,
      if (cleanedSortDirections.length > 0 || filterInputComponent != null) {
        finalClassName += 'sort-by-' + dataIndex + ' ';
        tempFilterConfigs[dataIndex] = {
          sortDirections: cleanedSortDirections,
          sortState: {
            direction: constants.emptySortDirection,
            priority: constants.emptySortPriority,
          },
          filterState: constants.emptyFilterState,
        };
      }
      // push the filtered down column content to our temporary store.
      tempTranslatedColumns.push({
        dataIndex,
        className: finalClassName,
        /* Only apply column widths in fixed table layouts to ensure consistency between safari and chromium*/
        width: tableLayout === 'fixed' ? width : undefined,
        title: (
          <HeaderCellContent
            title={title}
            hasSorting={cleanedSortDirections.length > 0}
            dataIndex={dataIndex}
            filterInputComponent={filterInputComponent}
            formatter={formatter}
            empty={empty}
          />
        ),
        ...column,
      });
    },
  );
  return { tempTranslatedColumns, tempFilterConfigs };
};

export default translateColumns;
